"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const enums_1 = require("../enums");
const ID_MAP = [
    {
        idType: 'CMRN',
        system: 'utah',
        primary: true,
        pingAttribute: 'intmtUnitNumber',
        assigningAuthority: 'INMT',
        mhpHeader: enums_1.DFDHeaders.consumerId,
    },
    {
        idType: 'CERNER_PERSON_ID',
        system: 'utah',
        primary: false,
        pingAttribute: 'intmtCernerPersonId',
        assigningAuthority: 'ICENTRA',
        mhpHeader: enums_1.DFDHeaders.patientId,
    },
];
//# sourceMappingURL=id-map.types.js.map